module.exports = __webpack_public_path__ + "img/livre-dechiffrage.b872c944.png";